import React, { useEffect, useState } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { Menu, X, ArrowLeft, Home } from "lucide-react";
import { DesktopSidebar } from "./DesktopSidebar";
import { Logo } from "./Logo";
import { OnboardingTour } from "./OnboardingTour";
import { SellerOnboardingTour } from "./SellerOnboardingTour";

const ROOT_PATHS = ["/", "/discover", "/home"];

export function DesktopShell() {
  const navigate = useNavigate();
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);

  // Close the mobile drawer whenever the route changes.
  useEffect(() => { setDrawerOpen(false); }, [location.pathname]);

  const showBack = !ROOT_PATHS.includes(location.pathname);

  return (
    <div className="ss-shell">
      {/* Desktop sidebar (hidden < 1024px via CSS) */}
      <DesktopSidebar />

      {/* Mobile slide-in drawer */}
      {drawerOpen && (
        <div className="ss-drawer-back" onClick={() => setDrawerOpen(false)} data-testid="sidebar-drawer">
          <div className="ss-drawer" onClick={(e) => e.stopPropagation()}>
            <button className="ss-drawer-close" onClick={() => setDrawerOpen(false)} data-testid="drawer-close"><X size={20} /></button>
            <DesktopSidebar />
          </div>
        </div>
      )}

      <div className="ss-main">
        <div className="ss-topbar">
          <button className="disc-search" style={{ width: 42, height: 42 }} onClick={() => setDrawerOpen(true)} data-testid="topbar-menu">
            <Menu size={20} />
          </button>
          <div onClick={() => navigate("/")} style={{ cursor: "pointer", display: "flex", alignItems: "center" }}>
            <Logo height={64} />
          </div>
          <div style={{ width: 42 }} />
        </div>
        <div className="ss-content">
          {showBack && (
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 14 }}>
              <button className="ss-btn ss-btn-ghost ss-btn-sm ss-back-btn" onClick={() => navigate(-1)} data-testid="global-back-button">
                <ArrowLeft size={16} /> Back
              </button>
              <button className="ss-btn ss-btn-ghost ss-btn-sm" onClick={() => navigate("/")} data-testid="global-home-button">
                <Home size={16} /> Home
              </button>
            </div>
          )}
          <Outlet />
        </div>
      </div>
      <OnboardingTour />
      <SellerOnboardingTour />
    </div>
  );
}
